import { useMutation, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';

import { energyApi } from '../api';
import { EMASatisfactionType, SatisfactionByDate } from '@demind-inc/core';

interface UseUpdateSatisfactionEmaParams {
  userId: string;
  date: string;
  satisfaction: EMASatisfactionType;
}

export function useUpdateSatisfactionEma() {
  const queryClient = useQueryClient();

  const updateSatisfactionEmaMutation = useMutation({
    mutationFn: ({ userId, date, satisfaction }: UseUpdateSatisfactionEmaParams) => {
      return energyApi.updateSatisfactionEma(userId, date, { satisfaction });
    },
    onMutate: async ({ userId, date, satisfaction }) => {
      await queryClient.cancelQueries({ queryKey: ['lifestack.satisfactionEma'] });
      const startDate = dayjs(date).startOf('month').format('YYYY-MM-DD');
      const endDate = dayjs(date).endOf('month').format('YYYY-MM-DD');
      queryClient.setQueriesData<SatisfactionByDate[]>(
        { queryKey: ['lifestack.satisfactionEma', { userId, startDate, endDate }] },
        (old) => {
          return old?.map((item) =>
            item.date === date
              ? {
                  ...item,
                  satisfaction: {
                    timestamp: item.satisfaction?.timestamp || new Date().toISOString(),
                    value: satisfaction,
                  },
                }
              : item
          );
        }
      );
    },
    onSuccess: (_) => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.satisfactionEma'] });
    },
  });

  return {
    updateSatisfactionEma: updateSatisfactionEmaMutation.mutateAsync,
    ...updateSatisfactionEmaMutation,
  };
}
